import React from 'react';
import { Modal, Table, Tag, Statistic, Row, Col, Card, DatePicker, Space, Divider } from 'antd';
import { ClockCircleOutlined, CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; 
dayjs.extend(utc);

const { RangePicker } = DatePicker;

const EmployeeShiftsModal = ({ visible, onCancel, data, loading, dateRange, onDateChange,employee }) => {
console.log(employee,"employee");

    const columns = [
        {
            title: 'Entry Time',
            dataIndex: 'entryDateTime',
            render: (date) => (
                <div className="flex flex-col">
                    <span className="font-medium text-gray-700">{dayjs.utc(date).local().format('DD MMM YYYY')}</span>
                    <span className="text-primary text-xs">{dayjs.utc(date).local().format('hh:mm A')}</span>
                </div>
            ),
        },
        {
            title: 'Exit Time',
            dataIndex: 'exitDateTime',
            render: (date) => date ? (
                <div className="flex flex-col">
                    <span className="font-medium text-gray-700">{dayjs.utc(date).local().format('DD MMM YYYY')}</span>
                    <span className="text-gray-400 text-xs">{dayjs.utc(date).local().format('hh:mm A')}</span>
                </div>
            ) : <Tag className='animate-pulse rounded-full' color="green-inverse">Currently working</Tag>,
        },
        {
            title: 'Worked Hours',
            dataIndex: 'workedHours',
            render: (hours) => hours ? (
                <Tag color="cyan">{Math.floor(hours)}h {Math.round((hours % 1) * 60)}m</Tag>
            ) : '-',
        },
        {
            title: 'Base Hours',
            dataIndex: 'baseHours',
            render: (hours) => hours ? (
                <Tag color="green">{Math.floor(hours)}h {Math.round((hours % 1) * 60)}m</Tag>
            ) : '-',
        },
        {
            title: 'Extra Hours',
            dataIndex: 'extraHours',
            render: (hours) => hours ? (
                <Tag color="orange">{Math.floor(hours)}h {Math.round((hours % 1) * 60)}m</Tag>
            ) : '-',
        },
    ];

    return (
        <Modal
            title={
                <div>
                    <div className="text-primary text-xl font-bold">Shift History Of: {data?.fullName}</div>
                </div>
            }
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={1100}
        >
            <div className="py-4">
                {/* FILTER SECTION */}
                <div className="bg-gray-50 p-4 rounded-lg mb-6 flex flex-wrap justify-between items-center gap-4 border border-gray-100">
                    <Space direction="vertical">
                        <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Filter by Date Range ( { data?.shifts.length} day)</span>
                        <RangePicker 
                            value={dateRange}
                            onChange={(dates) => onDateChange(dates)}
                            className="border-primary"
                            format="YYYY-MM-DD"
                        />
                    </Space>

                    
                    <div className="flex gap-4">
                       
                        <Statistic 
                            title="Base Hours" 
                            value={data?.totalBaseHours || 0} 
                            precision={2} 
                            suffix="Hrs"
                            valueStyle={{ color: 'gray' }}
                        />
                            <Divider type='vertical' className='h-16' />
                        <Statistic 
                            title="Extra Hours" 
                            value={data?.totalExtraHours || 0} 
                            precision={2} 
                            suffix="Hrs"
                            valueStyle={{ color: '#52c41a' }}
                        />
                        <Divider type='vertical' className='h-16' />
                         <Statistic 
                            title="Total Worked Hours" 
                            value={data?.totalWorkedHours || 0} 
                            precision={2} 
                            suffix="Hrs"
                            valueStyle={{ color: '#298E9F' }}
                        />
                    </div>
                </div>

                <Table
                    dataSource={data?.shifts || []}
                    columns={columns}
                    loading={loading}
                    rowKey="id"
                    pagination={{ pageSize: 5 }}
                />
            </div>
        </Modal>
    );
};

export default EmployeeShiftsModal;